module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/screen2.4cff2e69.png";